import ApplicationConversationsView from './ApplicationConversationsView';

export default ApplicationConversationsView;
